import React, { useState, useEffect } from 'react';
//Bibliotecas
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

//Componentes
import FlexContainer from '../../../components/common/FlexContainer';
import Button, { SecondaryButton, TertiaryButton, DangerButton } from '../../../components/common/Button';
import Modal from '../../../components/common/Modal';
import Success from '../../../components/common/Success';
import Error from '../../../components/common/Error';
import Form from '../../../components/common/Form';
import Input from '../../../components/common/Input';
//Servicios
import CursoService from '../../../services/CursoService';

//Imágenes
import { Edit, Edit2, Trash } from 'react-feather'



function CursoCard({ curso, refresh }) {
  //Estados
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [cursoName, setCursoName] = useState(curso.nombreCurso);
  const [loading, setLoading] = useState(false);

  //Navigate
  const navigate = useNavigate();

  //Manipuladores
  function handleToggleDeleteModal() {
    setDeleteModal(!deleteModal);
    reset();
    setSuccess('');
  }

  function handleToggleEditModal() {
    setEditModal(!editModal);
    reset();
    setSuccess('');
  }

  //React Hook Form
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  //Handle Submit
  const submitEdit = (data) => {
    setLoading(true);
    CursoService.editarCurso(data, curso._id).then((res) => {
      setSuccess('El curso fue editado satisfactoriamente');
      refresh();  
      setLoading(false);
    }).catch((error) => {setError(error.data.message);setLoading(false);});
    reset();
  }

  const submitDelete = () => {
    setLoading(true);
    CursoService.eliminarCurso(curso._id).then((res) => {
      setSuccess('El curso fue eliminado satisfactoriamente');
      refresh();
      ;setLoading(false);
    }).catch((error) => {setError(error.data.message);setLoading(false);});
  }



  return (
    <FlexContainer width='auto' height='auto' borderRadius='8px' key={curso._id} padding='8px 16px 16px 16px' boxShadow='20px 20px 40px rgba(0, 0, 0, 0.25)'>
      <Buttons>
        <TertiaryButton margin='0' padding='0' width='32px'  color='var(--color-azul-oscuro)' hoverColor={'var(--color-azul-claro)'} onClick={handleToggleEditModal}><Edit /></TertiaryButton>
        <TertiaryButton margin='0' padding='0' width='32px'  color='var(--color-error)' hoverColor={'#E34242'} onClick={handleToggleDeleteModal}><Trash /></TertiaryButton>
      </Buttons>
      <Title>{curso.nombreCurso}</Title>
      <Tags>
        <Tag><span>Código de acceso: </span>{curso.codigo}</Tag>
        <Tag><span>Número de estudiantes: </span>{curso.numeroEstudiantes}</Tag>
      </Tags>
      <Button margin='0px' onClick={() => navigate(`../progreso/${curso.codigo}/${curso.nombreCurso}`)}>Ver Calificaciones</Button>
      <Modal state={deleteModal} setState={setDeleteModal} title="Eliminar curso" padding='0' headerPadding='16px' >
      {!success &&
        <FlexContainer borderRadius='5px'>
          <Message>Se eliminará permanentemente el curso <span>{curso.nombreCurso}</span><br /> ¿Estás seguro de que quieres eliminarlo?</Message>
          <FlexContainer borderRadius='5px' flexDirection='row' margin='16px 0 0 0' justifyContent='right' backgroundColor='var(--color-gris-claro)' padding='16px' >
            <SecondaryButton width='30%' margin='0 16px' onClick={handleToggleDeleteModal} disabled={loading}>Cancelar</SecondaryButton>
            <DangerButton width='30%' margin='0' onClick={submitDelete} loading={loading} >Eliminar</DangerButton>
          </FlexContainer>
          <Error message={error}></Error>
        </FlexContainer>
      }
      <Success message={success} margin='32px'></Success>
      </Modal>
      <Modal state={editModal} setState={setEditModal} title="Editar curso" textAlign='left'>
        {!success &&
          <Form onSubmit={handleSubmit(submitEdit)} width='100%' padding='0px 32px' boxShadow='none'>
            <Input
              register={register}
              label='Nombre del curso'
              name='nombreCurso'
              placeholder="Ingresa el nuevo nombre del curso"
              value={cursoName}
              required={{ required: "El nuevo nombre del curso es obligatorio" }}
              error={errors.nombreCurso}
              onChange={(e) => setCursoName(e.target.value)}
            />
            <Button type='submit' margin='8px 0px 0px 0px ' loading={loading}><Edit2 />Editar</Button>
            <Error message={error}></Error>
          </Form>
        }
        <Success message={success}  margin='32px' ></Success>
      </Modal>
    </FlexContainer>
  )
}

export default CursoCard

const Title = styled.h3`
    color: var(--color-morado-oscuro);
    max-width:80%;
    height:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    word-break: break-all;
`;

const Buttons = styled.div`
    display:flex;
    align-self: flex-end;
`;

const Tags = styled.span`
    margin:16px 0px;
    display:flex;
    flex-direction:column;
`;

const Tag = styled.span`
    margin-bottom:8px;
    font-weight: 300;
    span{
      font-weight:700;
    }
`;

const Message = styled.span`
    padding:16px;
    font-weight: 400;
    span{
      font-weight:700;
    }
`;

